/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_Price_CustomInputs */

const en_lesson_price_custom = /** @type {(inputs: Lesson_Price_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`custom`)
};

const he_lesson_price_custom = /** @type {(inputs: Lesson_Price_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מותאם`)
};

/**
* | output |
* | --- |
* | "custom" |
*
* @param {Lesson_Price_CustomInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_price_custom = /** @type {((inputs?: Lesson_Price_CustomInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_Price_CustomInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_price_custom(inputs)
	return he_lesson_price_custom(inputs)
});